import CheckboxFieldPreview from "../PreviewItems/CheckboxFieldPreview";
import InitialsFieldPreview from "../PreviewItems/InitialsFieldPreview";
import PictureFieldPreview from "../PreviewItems/PictureFieldPreview";
import RadioFieldPreview from "../PreviewItems/RadioFieldPreview";
import SignatureFieldPreview from "../PreviewItems/SignatureFieldPreview";
import SubTitleFieldPreview from "../PreviewItems/SubTitleFieldPreview";
import TextFieldPreview from "../PreviewItems/TextFieldPreview";
import TitleFieldPreview from "../PreviewItems/TitleFieldPreview";
import VideoFieldPreview from "../PreviewItems/VideoFieldPreview";

export const PreviewcomponentMap: Record<string, any> = {
  title: TitleFieldPreview,
  subtitle: SubTitleFieldPreview,
  text: TextFieldPreview,
  checkbox: CheckboxFieldPreview,
  signature: SignatureFieldPreview,
  picture: PictureFieldPreview,
  input: InitialsFieldPreview,
  radio: RadioFieldPreview,
  video: VideoFieldPreview,
};
